/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-07-01 17:58:07
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-07-18 09:02:16
 * @FilePath: \大屏项目\src\utils\refresh-cpt-data.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import httpUtil from "@/utils/http-util";
import { MessagePlugin as Message } from 'tdesign-vue-next';
import { executeSelectApi } from "@/api/sql-execute-api";
import { getResByDatasetIdApi } from "@/api/dataset/dataset";
import { execMethod } from "@/utils/jsfunction-handler";
let urlParams = getUrlParam();
let curNumber = 0
let cache = {};

// 数组中value 全部都有值，就返回true
export function hasNonEmptyValues(arr) {
    return !arr?.some(item => item.value === '');
}
export function hasProperty(obj = {}, prop) {
    return prop in obj;
}
export async function getDataJson(cptDataForm, paras, fuc, current) {
    console.log("======textres====111", cptDataForm);
    console.log('qwdqdwqd');
    let resStr = '{}';//防止JSON解析报错
    let iptStr = cptDataForm.dataText
    if (cptDataForm.dataSource === 1) {
        resStr = JSON.parse(iptStr);
    } else if (cptDataForm.dataSource === 2) {//调接口
        iptStr = cptDataForm.apiUrl
        if (iptStr) {
            iptStr = mergeUrlParam(iptStr);
            console.log('asdwr9999999')
            await httpUtil.doRequest(iptStr, 'get').then(res => {
                resStr = res.data ? res.data : res;
            })
        } else {
            Message.error("接口地址不能为空");
        }
    } else if (cptDataForm.dataSource === 3) {
        iptStr = cptDataForm.sql
        if (iptStr) {
            iptStr = mergeUrlParam(iptStr);
            let staticData = JSON.parse(cptDataForm.dataText);
            const arrayApi = Array.isArray(staticData);
            await executeSelectApi({ sql: iptStr, datasourceId: cptDataForm.datasourceId, isArray: arrayApi }).then(res => {
                resStr = res.data ? res.data : res;
            })
        } else {
            Message.error("SQL不能为空");
        }
    } else if (cptDataForm.dataSource === 4) {


        let urlParamsed = getUrlParam();
        if (paras) {
            if (!urlParamsed) {
                urlParamsed = paras
            } else {
                urlParamsed = Object.assign(urlParamsed, paras)
            }
        }
        iptStr = cptDataForm.datasetId
        if (iptStr) {
            curNumber++
            // console.log(cptDataForm,'cptDataForm123123123123123')
            getData(iptStr, cptDataForm, urlParamsed).then(res => {

                fuc(res)
            })

            if (curNumber == sessionStorage.getItem('componentsNumber')) {
                curNumber = 0
                sessionStorage.setItem('componentsNumber', 0)
                cache = {}
            }
        } else {
            // console.log(cptDataForm,'gggggggggggggggggg')
            // console.log(paras,'gggggggggggggggggg')
            if (current) {
                Message.error(current.cptTitle + " 请选择数据集");
            } else {
                Message.error(" 请选择数据集");
            }


        }
        return false
    } else if (cptDataForm.dataSource === 5) {
        if (!cptDataForm.newMsg) {//newMsg:新消息
            return {}
        }
        return cptDataForm.newMsg
    } else if (cptDataForm.dataSource === 6) {
        let cacheKey = cptDataForm.cacheKey;
        console.log(decodeURIComponent(getUrlParam()[cacheKey]), 'iuaysdiuasdyiuas')
        let arr = decodeURIComponent(getUrlParam()[cacheKey] || '');
        if (!arr) {
            arr = localStorage.getItem(cacheKey) || '[]'
        }
        let cacheList = JSON.parse(arr)
        resStr = cacheList;
    }
    fuc(resStr);
}

function getData(iptStr, cptDataForm, urlParamsed) {
    // const sqlStore = useSQLStore();
    // const isCacheEnabled = sqlStore.isCache; // 获取isCache的值
    // console.log('Cache status:', cptDataForm.hasOwnProperty('isCache'),cptDataForm.isCache);
    // 将参数对象转换为字符串
    let key = iptStr + JSON.stringify(urlParamsed);
    if (cptDataForm.hasOwnProperty('isCache') && cptDataForm.isCache) {//不缓存数据
        return getPro(iptStr, cptDataForm, urlParamsed, key)
    } else {
        if (key in cache) {
            // console.log('返回缓存数据',cache[key])
            return cache[key];
        } else {
            // console.log(iptStr,cptDataForm, urlParamsed)
            return getPro(iptStr, cptDataForm, urlParamsed, key)
        }

    }
}
function getPro(iptStr, cptDataForm, urlParamsed, key) {
    // 如果缓存中没有数据，创建一个新的 Promise

    let promise = getResByDatasetIdApi(iptStr, cptDataForm.datasetType, urlParamsed)
        .then(res => {
            let resStr, jsFunction, total;
            jsFunction = res.data.jsFunction == null ? true : false;
            resStr = execMethod(res.data.jsFunction, res.data.apiRes);
            if (res.data?.total) {
                total = res.data?.total;
            }
            if (res.data.jsFunction == null) {
                return {
                    resStr,
                    jsFunction,
                    total
                };
            } else {
                return resStr
            }
        });

    cache[key] = promise;
    return promise;
}

let cptTimer = {}

export function pollingRefresh(uuid, cptDataForm, loadData, components) {
    if (uuid) {
        clearInterval(cptTimer[uuid]);//清除旧的定时器
    }
    if (!cptDataForm) {
        // Message.warning("cptDataForm==>null");
        return;
    }
    if (!loadData) {
        Message.warning("子组件未实现数据解析方法");
        return;
    }
    loadData();
    if (cptDataForm.pollTime && cptDataForm.pollTime > 0) {//轮询

        cptTimer[uuid] = setInterval(function () {
            // 是否是编辑模式
            let isDesign = location.href.includes('/design')
            if (isDesign) return
            console.log(components, 'componentscomponents')
            let groupedComponents = components && components
                .filter(component => component.cptOption && component.cptOption.cptDataForm && component.cptOption.cptDataForm.pollTime > 0)
                .reduce((acc, current) => {
                    let key = current.cptOption.cptDataForm.pollTime;
                    if (!acc[key]) {
                        acc[key] = [current];
                    } else {
                        acc[key].push(current);
                    }
                    return acc;
                }, {});

            console.log(groupedComponents, 'pppppppppppppppppppppppppppppppkkkkkkkk');
            // console.log(groupedComponents[cptDataForm.pollTime], cptDataForm.pollTime, 'pppppppppppppppppppppppppppppppkkkkkkkk');
            if (groupedComponents) {
                sessionStorage.setItem('componentsNumber', groupedComponents[cptDataForm.pollTime]?.length)
            }

            loadData();
        }, cptDataForm.pollTime * 1000)
    }
}

export function clearCptInterval(uuid, clearAll) {
    if (uuid) {
        clearInterval(cptTimer[uuid]);//清除旧的定时器
    }
    if (clearAll) {
        for (const key in cptTimer) {
            clearInterval(cptTimer[key]);
        }
    }
}

function mergeUrlParam(str) {
    let sp = str.split('${url.');
    for (let i = 1; i < sp.length; i++) {
        const rightStr = sp[i]
        const urlKey = rightStr.split('}')[0]
        const hasKey = Object.prototype.hasOwnProperty.call(urlParams, urlKey);
        str = str.replaceAll('${url.' + urlKey + '}', (hasKey ? urlParams[urlKey] : ''))
    }
    return str;
}

function getUrlParam() {
    const queryString = window.location.search.slice(1);
    let params = Object.create(null)
    if (queryString) {
        let arrObj = queryString.split("&");
        arrObj.forEach(item => {
            item = item.split("=");
            params[item[0]] = item[1]
        })
    }

    // if ('reloadTimeKey' in params) {
    //     delete params.reloadTimeKey
    // }
    return params;
}

export function getUrlParamMethod() {
    const queryString = window.location.search.slice(1);
    let params = Object.create(null)
    if (queryString) {
        let arrObj = queryString.split("&");
        arrObj.forEach(item => {
            item = item.split("=");
            params[item[0]] = decodeURIComponent(item[1])
        })
    }
    return params;
}

// 获取默认值
export function getDefaultValue(attr, type, option) {
    const { defaultValueType, defaultValue, defaultValueCurrentID } = attr
    console.log(attr, type, 'defaultValueType, defaultValuedefaultValueType, defaultValuedefaultValueType, defaultValue');
    let result
    console.log(defaultValueType == null && (defaultValue == undefined || defaultValue == null || defaultValue == ''), 'qwdqdqdqd');
    if (defaultValueType == null && (defaultValue == undefined || defaultValue == null || defaultValue == '')) {
        return false
    }
    console.log(defaultValueType, 'defaultValueType');
    // 设置默认值
    if (defaultValueType == 0) {
        // 固定值
        if (type == 'cpt-date-picker' || 'cpt-date-picker-mobile') {
            if (attr.daterange) {
                result = [defaultValue, attr.defaultValueEnd];
            } else {
                result = defaultValue;
            }
        } else {
            result = defaultValue;
        }
    } else if (defaultValueType == 1) {
        // url参数key
        if (type == 'cpt-date-picker' || 'cpt-date-picker-mobile') {
            if (attr.daterange) {
                let urlParams = getUrlParamMethod();
                result = [urlParams[defaultValue], urlParams[attr.defaultValueEnd]];
            } else {
                let urlParams = getUrlParamMethod();
                result = urlParams[defaultValue];
            }
        } else {
            let urlParams = getUrlParamMethod();
            result = urlParams[defaultValue];
        }
    } else if (defaultValueType == 2) {
        if (type == 'cpt-date-picker' || 'cpt-date-picker-mobile') {
            if (attr.daterange) {
                let storageValue = sessionStorage.getItem(defaultValue);
                let storageValueEnd = sessionStorage.getItem(defaultValueEnd);
                result = [storageValue, storageValueEnd];
            } else {
                let storageValue = sessionStorage.getItem(defaultValue);
                result = storageValue;
            }
        } else {
            let storageValue = sessionStorage.getItem(defaultValue);
            result = storageValue;
        }

    } else if (defaultValueType == 3) {
        console.log('type', type);
        //公式 日期
        if (type == 'cpt-date-picker' || 'cpt-date-picker-mobile') {
            if (attr.daterange) { //开始与结束 两个日期
                // console.log('两个日期',attr)
                let expressionStart = attr.defaultValue.replace(/当年|当月|当日/g, function (matched) {
                    return generateFunctionName(matched);
                });//funcMethode(attr.defaultValueEN,attr.defaultValue)
                let expressionEnd = attr.defaultValueEnd.replace(/当年|当月|当日/g, function (matched) {
                    return generateFunctionName(matched);
                }); //funcMethode(attr.defaultValueEndEN,attr.defaultValueEnd)
                let start, end;
                try {
                    start = eval(expressionStart);
                    // 如果代码执行无误，则result将存储执行结果
                } catch (error) {
                    // 如果代码中有语法错误或者运行时错误，这里会捕获到错误信息
                    Message.error("开始日期表达式错误");
                }
                try {
                    end = eval(expressionEnd);
                    // 如果代码执行无误，则result将存储执行结果
                } catch (error) {
                    // 如果代码中有语法错误或者运行时错误，这里会捕获到错误信息
                    Message.error("结束日期表达式错误");
                }
                // console.log(start,end,'**')/
                result = [start, end];
            } else {  // 一个日期
                //  console.log('一个日期',attr);
                let expression = attr.defaultValue.replace(/当年|当月|当日/g, function (matched) {
                    return generateFunctionName(matched);
                });
                console.log(expression, 'expression');
                try {
                    let start = eval(expression);
                    result = start
                    // 如果代码执行无误，则result将存储执行结果
                } catch (error) {
                    // 如果代码中有语法错误或者运行时错误，这里会捕获到错误信息
                    Message.error("表达式错误");
                }
            }
        }
    } else if (defaultValueType == 4) {

        result = option && option[0].value

    } else {
        return false
    }
    console.log(result, 'resultresultresultresultresult');
    return result
}
// 定义一个函数用于生成对应的函数名，如：当年 -> YEAR()
function generateFunctionName(datePart) {
    return datePart + '()';
}
// function funcMethode(attr,nameValue)  {
//     // YEAR(YEAR(TYEAR(),1),1)
//     // YEAR(TYEAR(),1)
//     // var methodName = attr.defaultValueEN.split("(")[0]; //方法名
//     // var params = attr.defaultValueEN.substring(attr.defaultValueEN.indexOf("(") + 1, attr.defaultValueEN.lastIndexOf(")")).split(","); //方法参数
//     var methodName = attr.split("(")[0];
//     var params = attr.substring(attr.indexOf("(") + 1, attr.lastIndexOf(")")).split(",");
//     var paramsTwo = nameValue.substring(nameValue.indexOf("(") + 1, nameValue.lastIndexOf(")")).split(",");
//     console.log(paramsTwo.length-1,'*')
//     console.log(methodName,params,paramsTwo,paramsTwo[paramsTwo.length-1],'paramsTwo')
//     if(params.length > 1) { // 有参数需要方法调方法
//         console.log(params[0],'*')
//         // if(typeof params[0] == String) {

//         // } else {

//         // }
//         const year = paramsMethod(params[0].split("(")[0]);
//         return paramsMethod(methodName,[year,paramsTwo[paramsTwo.length-1]])

//         // for (var i = 0; i < params.length; i++) {
//         //    paramsMethod(params[i].split("("))
//         //    params[i] = params[i].trim();
//         //  }
//     } else { // 没有参数直接调方法
//         return paramsMethod(methodName,'')
//     }
// }

// function paramsMethod(type,params) {
//     console.log(params,'params')
//     switch (type) {
//         case "TYEAR":
//             return func.TYEAR();
//         case "TMONTH":
//             return func.TMONTH();
//         case "TDAY":
//             return func.TDAY();
//         case "YEAR":
//             return func.YEAR(parseInt(params[0]), parseInt(params[1]));
//         case "YEARMONTH":
//             return func.YEARMONTH(params[0], parseInt(params[1]));
//         case "YEARMONTHDAY":
//             return func.YEARMONTHDAY(params[0], parseInt(params[1]));
//         default:
//             break;
//             // console.log("Invalid method name: " + method);
//     } 
// }
function 当年() {  // TYEAR()
    return new Date().getFullYear();
}
function 当月() {  // TMONTH()
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    return year + "-" + (month < 10 ? "0" : "") + month;
}
function 当日() {  // TDAY()
    let year = new Date().getFullYear();
    let month = new Date().getMonth() + 1;
    let day = new Date().getDate();
    return year + "-" + (month < 10 ? "0" : "") + month + "-" + (day < 10 ? "0" : "") + day;
}
function 年计算(year, num) {   //YEAR(2023,1)   YEAR(2023,-1)
    const date = new Date(year, 0)
    date.setFullYear(date.getFullYear() + num)
    return date.getFullYear()
}
function 月计算(dateStr, num) { //YEARMONTH(2023-12,1)  YEARMONTH(2023-12,-1)
    const date = new Date(dateStr + "-01");
    date.setMonth(date.getMonth() + num);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    return `${year}-${month}`;
}
function 日期计算(date, num) {  //YEARMONTHDAY(2023-12-01,5)  YEARMONTHDAY(2023-12-01,-1)
    const currentDate = new Date(date);
    const futureDate = new Date(currentDate.setDate(currentDate.getDate() + num));
    const year = futureDate.getFullYear();
    const month = (futureDate.getMonth() + 1).toString().padStart(2, '0');
    const day = futureDate.getDate().toString().padStart(2, '0');
    // 获取并格式化时分秒
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    // return `${year}-${month}-${day}`;
}





